import format from 'date-fns/format';
import parseISO from 'date-fns/parseISO';

export default function parseDateRange(start: string, end: string) {
  return `${format(parseISO(start), 'dd.MM.yyyy')} - ${format(
    parseISO(end),
    'dd.MM.yyyy'
  )}`;
}
